
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getBlockgroupGeometry",
      resolverType: "query",
      routePath: "/getBlockgroupGeometry",
      httpMethod: "POST",
    });
  